import { render, staticRenderFns } from "./ToggleVideoBtn.vue?vue&type=template&id=646131e0&"
import script from "./ToggleVideoBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleVideoBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports